import { render, staticRenderFns } from "./EModalDuplicarAula.vue?vue&type=template&id=3b69791c"
import script from "./EModalDuplicarAula.vue?vue&type=script&lang=js"
export * from "./EModalDuplicarAula.vue?vue&type=script&lang=js"
import style0 from "./EModalDuplicarAula.vue?vue&type=style&index=0&id=3b69791c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports